import styled from "@emotion/styled";

// Used in two places on wrap completed and trade completed
export const DoubleCTAButtonContainer = styled.div`
  display: flex;
  gap: 10px;
  // 768px is what bootstrap classes as mobile it's the same size we use for order completed CTA buttons container
  @media (max-width: 768px) {
    flex-direction: column;
  }
`;
